var Theme = Theme || {};


Theme.DocumentViewerEpub = (function ($) {
    let $viewer;
    let _pageBoundaries = [];
    let _shouldGotoLastPageOnIframeLoad = false;
    let _paginationTriggeredScrollEvent = false;
    
    return {
        init: initEpubViewer
    };
    
    function initEpubViewer($epubViewer) {
        if($epubViewer.length) {
            $viewer = $epubViewer;
            $('.js-document-viewer-nextpage').on('click', nextPage);
            $('.js-document-viewer-previouspage').on('click', prevPage);
            $('.js-epub-toc').on('click', 'a', handleEpubTocLinkClick);
            $viewer.on('load', function(){
                let eReaderPaginationInformation = calculatePageBoundaries();
                _pageBoundaries = eReaderPaginationInformation.pageBoundaries;

                $viewer.attr('data-page-count', eReaderPaginationInformation.totalPages);

                $(this.contentWindow).on('scroll', debounce(trackPagePositionOnScroll, 250));
                $viewer.contents()
                    .off('click')
                    .on('click','a:not([target="_blank"])', handleEpubInlineJumpLinks);

                let gotoElement = $viewer.attr('data-goto');
                if(gotoElement.length){
                    goToInlineLinkWithinCurrentDoc(gotoElement);
                    $viewer.attr('data-goto', '');
                }

                if(_shouldGotoLastPageOnIframeLoad) {
                    let lastPage = getTotalPageCount();
                    goToPage(lastPage);
                    _shouldGotoLastPageOnIframeLoad = false;
                }
                enableDisablePaginationButtons();
            });
        }
    }
        
    function trackPagePositionOnScroll() {
        if(_paginationTriggeredScrollEvent) {
            _paginationTriggeredScrollEvent = false;
            return;
        }
     
        let currentPage = lookupPageBasedOnElemOffset();
        setCurrentPage(currentPage);
        enableDisablePaginationButtons();
    }

    function calculatePageBoundaries() {
        let pageBoundaryInformation = [];
        let eReaderPaginationInfo = {};
        
        let $iframeContents = $viewer.contents();
        let iframeHeight = $viewer.height();
        let totalContentHeight = $iframeContents.find('html').outerHeight(true);
        let totalPages = Math.ceil(totalContentHeight / iframeHeight);
        
        for (let i = 0; i < totalPages; i++) {
            let start = i * iframeHeight;
            let end = start + iframeHeight;
            if (i === totalPages - 1) {
                end = totalContentHeight; 
            }
            
            pageBoundaryInformation[i] = { start: start, end: end };
        }

        eReaderPaginationInfo.pageBoundaries = pageBoundaryInformation;
        eReaderPaginationInfo.totalPages = totalPages;
        
        return eReaderPaginationInfo
    }
    
    function lookupPageBasedOnElemOffset(elementOffset) {
        const scrollTop = elementOffset !== undefined ? elementOffset : $viewer.contents().scrollTop();
        let currentPage = 1;
        const iframeHeight = $viewer.height();
        const middleOfScreen = scrollTop + (iframeHeight / 2);
        
        let pageIndex = _pageBoundaries.findIndex(page => {
            return middleOfScreen >= page.start && middleOfScreen < page.end;
        });
        
        if(pageIndex !== -1) {
            currentPage = convertZeroBasedIndexToPageNumber(pageIndex);
        }
        
        return currentPage;
    }

    function enableDisablePaginationButtons() {
        let $spineElementDiv = $('.js-epub-spine');
        let $spineElements = $spineElementDiv.find("a");
        let firstSpineItem = $spineElements.first();
        let lastSpineItem = $spineElements.last();
        let $nextPageBtn = $('.js-document-viewer-nextpage');
        let $prevPageBtn = $('.js-document-viewer-previouspage');
        let currentSpineItemId = getActiveSpineItem();
        let currentPage = getCurrentPage();
        
        if((currentSpineItemId === lastSpineItem.attr('id')) && currentPage === getTotalPageCount()) {
            $nextPageBtn.addClass('disabled');
        }
        else {
            $nextPageBtn.removeClass('disabled');
        }

        if(currentSpineItemId === firstSpineItem.attr('id') && currentPage === 1) {
            $prevPageBtn.addClass('disabled');
        }
        else {
            $prevPageBtn.removeClass('disabled');
        }
    }
    function getTotalPageCount(){
        return parseInt($viewer.attr('data-page-count'));
    }
    
    function goToInlineLinkWithinCurrentDoc(elementId) {
        let escapedSelector = getEscapedSelector(elementId);
        let targetElemId = escapedSelector.startsWith('#') ? escapedSelector : `#${escapedSelector}`;
        let $iframeContents = $viewer.contents();
        let $targetElem = $iframeContents.find(targetElemId);
        
        if ($targetElem.length) {
            let elementOffset = $targetElem.offset().top;
            $iframeContents.scrollTop(elementOffset);
        }
    }
    
    function getEscapedSelector(elemId){
        return elemId.replace(/([:.\[\],=@!\$^&*()+\?>`~|\{\}\\])/g, '\\$1');
    }

    function locateSpineItemIdByHref(linkHref) {
        let $epubSpineItem = $('.js-epub-spine').find(`a[href*="${linkHref}"]`);
        return $epubSpineItem.attr('id');
    }

    function setGotoAttribute(elementId) {
        $viewer.attr('data-goto', elementId);
    }
    
    function handleEpubInlineJumpLinks(e) {
        e.preventDefault();
        let $this = $(this);
        let linkHref = $this.attr('href');
        let hrefParts = linkHref.split('#');
        let linkHrefFileName = hrefParts.length > 0 ? hrefParts[0] : '';
        let elementId = hrefParts.length >= 2 ? hrefParts[1] : '';
        let spineRefId = linkHrefFileName && linkHrefFileName !== '' ? locateSpineItemIdByHref(linkHrefFileName) : undefined;
        let isJumpLinkInSameDocument = isJumpLinkInCurrentDocument(spineRefId);
        
        if(isJumpLinkToDifferentDocument(linkHref, isJumpLinkInSameDocument)) {
            handleJumpToDifferentDocument($this, spineRefId, elementId);
        } else if (elementId) {
            goToInlineLinkWithinCurrentDoc(elementId);
        }
    }
    
    function isJumpLinkToDifferentDocument(linkHref, isJumpLinkInSameDocument) {
        return (linkHref.includes('.xhtml') || linkHref.includes('.html')) && !isJumpLinkInSameDocument;
    }
    
    function handleJumpToDifferentDocument($link, spineRefId, targetElementId) {
        if (spineRefId !== undefined) {
            setCurrentPage(1);
            setActiveSpineItem(spineRefId);
        }
        
        let iframeSrcUrl = buildIframeSrcUrl($link);
        setGotoAttribute(targetElementId);
        $viewer.attr('src', iframeSrcUrl);
    }
    
    function isJumpLinkInCurrentDocument(spineRefId) {
        if(spineRefId !== undefined) {
            let currentlyActiveSpineItem = getActiveSpineItem();
            return spineRefId === currentlyActiveSpineItem;
        }
        return false;
    }
    
    function handleEpubTocLinkClick(e){
        e.preventDefault();
        let $this = $(this);
        let $epubToc = $('.js-epub-toc');
        let tocLinkHref = $this.attr('href');
        let $currentActiveTocLink = $epubToc.find('.active');
        $currentActiveTocLink.removeClass('active');
        $this.addClass('active');

        let hrefHash = $this.prop('hash');
        if(hrefHash.length) {
            let tocLinkHrefParts = tocLinkHref.split('#');
            let spineRefId = locateSpineItemIdByHref(tocLinkHrefParts[0]);
            if(spineRefId !== undefined) {
                setActiveSpineItem(spineRefId);
            }
            if(tocLinkHrefParts.length > 1) {
                setGotoAttribute(hrefHash);
            }
        }
        else {
            let spineRefId = locateSpineItemIdByHref(tocLinkHref);
            if (spineRefId !== undefined) {
                setActiveSpineItem(spineRefId);
            }
        }
        setCurrentPage(1)
        updateIframeSrcUrl($this);
    }

    function setActiveSpineItem(spineItemId) {
        if(spineItemId === null || spineItemId === undefined) {
            return;
        }
  
        $('.js-epub-spine').attr('data-active-spine-itemid', spineItemId);
    }
    
    function getActiveSpineItem() {
        return $('.js-epub-spine').attr('data-active-spine-itemid');
    }

    function setCurrentPage(pageNumber) {
        $viewer.attr('data-current-page', pageNumber);
    }

    function convertPageNumberToZeroBasedIndex(pageNumber) {
        return pageNumber - 1;
    }
    
    function convertZeroBasedIndexToPageNumber(index) {
        return index + 1;
    }

    function goToPage(pageNumber) {
        let zeroBasedPageNumber = convertPageNumberToZeroBasedIndex(pageNumber);
        let pageOffset = _pageBoundaries[zeroBasedPageNumber];
        
        if (pageOffset !== undefined) {
            _paginationTriggeredScrollEvent = true;
            $viewer.contents().scrollTop(pageOffset.start);
        }
        setCurrentPage(pageNumber);
        enableDisablePaginationButtons();
    }
    
    function loadSpineItem(spineRefId, isPrevious) {
        let $spine = $('.js-epub-spine');
        let $spineElem = $spine.find(`a[id="${spineRefId}"]`);
        _shouldGotoLastPageOnIframeLoad = isPrevious;
        $spine.data('active-spine-itemid', spineRefId);
        setCurrentPage(1);
        updateIframeSrcUrl($spineElem);
    }
    
        
    function nextPage() {
        let currentPage = getCurrentPage();
        let nextPage = currentPage + 1;
              
        if (nextPage <= getTotalPageCount()) {
            goToPage(nextPage);
        }
        else{
            let nextSpineRefId = getNextSpineItemRefId();
            setActiveSpineItem(nextSpineRefId);
            loadSpineItem(nextSpineRefId, false);
        } 
    }
    
    function prevPage() {
        let currentPage = getCurrentPage();
        let previousPageNumber = currentPage - 1;
        if (previousPageNumber < 1) {
            let previousSpineRefId = getPrevSpineItemRefId();
            setActiveSpineItem(previousSpineRefId);
            loadSpineItem(previousSpineRefId, true);
        } else {
            goToPage(previousPageNumber);
        }
    }
    
    function getCurrentPage() {
        return parseInt($viewer.attr('data-current-page'));
    }
    function getNextSpineItemRefId() {
        let currentSpineRefId = getActiveSpineItem();
        let $nextSpineItem = $('.js-epub-spine').find(`a[id="${currentSpineRefId}"]`).next('a');
        return $nextSpineItem.length > 0 ? $nextSpineItem.attr('id') : null;
    }

    function getPrevSpineItemRefId() {
        let currentSpineRefId = getActiveSpineItem();
        let $prevSpineItem = $('.js-epub-spine').find(`a[id="${currentSpineRefId}"]`).prev('a');
        return $prevSpineItem.length > 0 ? $prevSpineItem.attr('id') : null;
    }
        
    function updateIframeSrcUrl($elem) {
        let elemHash = $elem.first().prop('hash');
        if(elemHash !== undefined){
            setGotoAttribute(elemHash)
        }
        let iframeSrcUrl = buildIframeSrcUrl($elem);
        $viewer.attr('src', iframeSrcUrl);
    }
    
    function buildIframeSrcUrl($elem) {
        let epubFileName = $elem.attr('href');
        let resourceInfo = getResourceInfo();
        let instanceName = $('#viewport').data('instancename');

        if(instanceName !== ''){
            instanceName = '/' + instanceName;
        }
        
        const urlParams = new URLSearchParams({
            parentResourceId: resourceInfo.parentResourceId,
            parentResourceType: resourceInfo.parentResourceType,
            multimediaType: resourceInfo.multimediaType,
            multimediaUrl: resourceInfo.multimediaUrl,
            epubSourceFileName: epubFileName
        });
        
        return `/DocumentViewer/EpubPage${instanceName}?${urlParams.toString()}`;
    }
    
    function getResourceInfo() {
        let $doc = $('#viewport');
        let resourceInfo = {};
        resourceInfo.multimediaUrl = $doc.data('multimediaurl');
        resourceInfo.multimediaType = $doc.data('multimediatype');
        resourceInfo.parentResourceId = $doc.data('parentresourceid');
        resourceInfo.parentResourceType = $doc.data('parentresourcetype');
        
        return resourceInfo;
    }
    
})(jQuery);